import { usePlaylistAssignmentsForPortal, usePlaylistAssignmentsPortals } from '.';
import { useHasGate } from '../accounts';
import { useParams } from 'react-router-dom';
import { TABLE_SIZE, useDisplayedData } from '../table';
export const usePlaylistAssignmentsGate = () => useHasGate('Academy:PlaylistAssignments');
export const usePlaylistAssignmentsParams = () => useParams();
export const useFilteredPlaylistAssignmentsPortals = ({
  playlistId,
  page = 1
}) => {
  const {
    playlistAssignmentsPortals,
    total,
    playlistAssignmentsPortalsLoading
  } = usePlaylistAssignmentsPortals({
    playlistId,
    offset: (page - 1) * TABLE_SIZE,
    count: TABLE_SIZE
  });
  const {
    playlistAssignmentsPortals: displayedPortals,
    total: displayedTotal
  } = useDisplayedData({
    playlistAssignmentsPortals,
    total
  }, playlistAssignmentsPortalsLoading) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    playlistAssignmentsPortals: displayedPortals,
    total: displayedTotal,
    playlistAssignmentsPortalsLoading,
    pageCount
  };
};
export const useFilteredPlaylistAssignmentsForPortal = ({
  playlistId,
  portalId,
  page = 1
}) => {
  const {
    playlistAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    total
  } = usePlaylistAssignmentsForPortal({
    playlistId,
    portalId,
    offset: (page - 1) * TABLE_SIZE,
    count: TABLE_SIZE
  });
  const {
    playlistAssignmentsForPortal: displayedAssignmentsForPortal,
    total: displayedTotal
  } = useDisplayedData({
    playlistAssignmentsForPortal,
    total
  }, playlistAssignmentsForPortalLoading) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    playlistAssignmentsForPortal: displayedAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    total: displayedTotal,
    pageCount
  };
};